import { css } from 'linaria';
import fonts from 'style/fonts';
import hover from 'style/mixins';
export const text = "t1ixdtah";
export const navlink = "n1qamd22";
export const number = "n1l21mts";
export const link = "l1ok5oi3";
export const line = "l2xyxf5";
export const lineInner = "l1h3gr2d";

require("/Users/florianmorel/Work/Websites/rudy-vermorel-2019/.linaria-cache/src/components/nav-link/styles.linaria.css");